import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private readonly SYNC_DIALOG_KEY = 'snycDialogOpen';

  constructor(private dialog: MatDialog) {
    // Cleanup on load — removes stale state if no dialogs are actually open
    if (this.dialog.openDialogs.length === 0) {
      localStorage.removeItem(this.SYNC_DIALOG_KEY);
    }
  }

  isSyncDialogOpen(): boolean {
    return localStorage.getItem(this.SYNC_DIALOG_KEY) === 'true';
  }

  markSyncDialogOpen() {
    localStorage.setItem(this.SYNC_DIALOG_KEY, 'true');
  }

  markSyncDialogClosed() {
    localStorage.removeItem(this.SYNC_DIALOG_KEY);
  }

  listenForSyncDialogClose(): Observable<void> {
    return this.dialog.afterAllClosed.pipe(
      tap(() => this.markSyncDialogClosed())
    );
  }

  isAnyDialogOpen(): boolean {
    return this.dialog.openDialogs.length > 0;
  }
}
